import InfluencerDetails from '@src/quince-site-common/src/domains/InfluencerDetails'

import Product from '../../domains/Product'
import PubSub from '../PubSub'

export interface SocialSectionState {
  showPopUp: boolean
  influencerDetails: InfluencerDetails[]
  influencerIndex: number
  isLoadingProducts: boolean
  products?: Product[]
  isHighlights: boolean
}

interface SetInfluencerPayload {
  influencerDetails: InfluencerDetails[]
  influencerIndex: number
  isLoadingProducts: boolean
  products?: Product[]
  isHighlights?: boolean
}

class SocialSectionStateManager extends PubSub {
  private socialSectionState: SocialSectionState

  constructor() {
    super()
    this.socialSectionState = {
      showPopUp: false,
      influencerDetails: [],
      influencerIndex: 0,
      products: [],
      isLoadingProducts: true,
      isHighlights: false,
    }
  }

  updateProductsAndLoadingState = (loadingState: boolean, products?: Product[]) => {
    if (this.socialSectionState.isLoadingProducts === loadingState && this.socialSectionState.products === products) {
      return
    }
    this.socialSectionState.isLoadingProducts = loadingState
    this.socialSectionState.products = products
    this.publish()
  }

  showSocialSectionPopUp = (payload: SetInfluencerPayload) => {
    this.socialSectionState.showPopUp = true
    this.socialSectionState.influencerDetails = payload.influencerDetails
    this.socialSectionState.influencerIndex = payload.influencerIndex
    this.socialSectionState.isLoadingProducts = payload.isLoadingProducts
    this.socialSectionState.products = payload.products
    this.socialSectionState.isHighlights = payload.isHighlights ?? false
    this.publish()
  }

  hideSocialSectionPopUp = () => {
    this.socialSectionState.showPopUp = false
    this.socialSectionState.isHighlights = false
    this.publish()
  }

  getSocialSectionState = () => this.socialSectionState
}

const socialSectionStateManager: SocialSectionStateManager =
  SocialSectionStateManager.getInstance('socialSectionStateManager')

export default socialSectionStateManager
